import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requireAdmin = false }) => {
  const { isAuthenticated, loading, isAdmin, isVenueUser } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // requireAdmin is the gate at the top of the /admin tree. Admin and venue
  // users are both legitimate admin-area users; SYSTEM_ADMIN-only sub-pages
  // (e.g. user management) gate themselves with isSystemAdmin() locally.
  // VENUE_USER's per-venue scoping is enforced by the API (venueAccessMiddleware)
  // and the sidebar; route-level enforcement could be added per-route later.
  if (requireAdmin && !(isAdmin() || isVenueUser())) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
